import {CountryOption} from "../../../utils/types";

const COUNTRIES: CountryOption[] = [
    {id: "US", name: "🇺🇸 United States (US)"},
    {id: "DE", name: "🇩🇪 Germany (DE)"},
    {id: "FR", name: "🇫🇷 France (FR)"},
    {id: "GB", name: "🇬🇧 United Kingdom (GB - UK)"},
    {id: "NL", name: "🇳🇱 Netherlands (NL)"},
    {id: "NO", name: "🇳🇴 Norway (NO)"},
    {id: "FI", name: "🇫🇮 Finland (FI)"},
    {id: "IT", name: "🇮🇹 Italy (IT)"},
    {id: "AT", name: "🇦🇹 Austria (AT)"},
    {id: "BR", name: "🇧🇷 Brazil (BR)"},
    {id: "ES", name: "🇪🇸 Spain (ES)"},
    {id: "CA", name: "🇨🇦 Canada (CA)"},
    {id: "PR", name: "🇵🇷 Puerto Rico (PR)"},
    {id: "DK", name: "🇩🇰 Denmark (DK)"},
    {id: "MX", name: "🇲🇽 Mexico (MX)"},
    {id: "AF", name: "🇦🇫 Afghanistan (AF)"},
    {id: "AX", name: "🇦🇽 Åland Islands (AX)"},
    {id: "AL", name: "🇦🇱 Albania (AL)"},
    {id: "DZ", name: "🇩🇿 Algeria (DZ)"},
    {id: "AS", name: "🇦🇸 American Samoa (AS)"},
    {id: "AD", name: "🇦🇩 Andorra (AD)"},
    {id: "AO", name: "🇦🇴 Angola (AO)"},
    {id: "AI", name: "🇦🇮 Anguilla (AI)"},
    {id: "AQ", name: "🇦🇶 Antarctica (AQ)"},
    {id: "AG", name: "🇦🇬 Antigua And Barbuda (AG)"},
    {id: "AR", name: "🇦🇷 Argentina (AR)"},
    {id: "AM", name: "🇦🇲 Armenia (AM)"},
    {id: "AW", name: "🇦🇼 Aruba (AW)"},
    {id: "AU", name: "🇦🇺 Australia (AU)"},
    {id: "AZ", name: "🇦🇿 Azerbaijan (AZ)"},
    {id: "BS", name: "🇧🇸 Bahamas (BS)"},
    {id: "BH", name: "🇧🇭 Bahrain (BH)"},
    {id: "BD", name: "🇧🇩 Bangladesh (BD)"},
    {id: "BB", name: "🇧🇧 Barbados (BB)"},
    {id: "BY", name: "🇧🇾 Belarus (BY)"},
    {id: "BE", name: "🇧🇪 Belgium (BE)"},
    {id: "BZ", name: "🇧🇿 Belize (BZ)"},
    {id: "BJ", name: "🇧🇯 Benin (BJ)"},
    {id: "BM", name: "🇧🇲 Bermuda (BM)"},
    {id: "BT", name: "🇧🇹 Bhutan (BT)"},
    {id: "BO", name: "🇧🇴 Bolivia, Plurinational State Of (BO)"},
    {id: "BQ", name: "🇧🇶 Bonaire, Saint Eustatius And Saba (BQ)"},
    {id: "BA", name: "🇧🇦 Bosnia & Herzegovina (BA)"},
    {id: "BW", name: "🇧🇼 Botswana (BW)"},
    {id: "BV", name: "🇧🇻 Bouvet Island (BV)"},
    {id: "IO", name: "🇮🇴 British Indian Ocean Territory (IO)"},
    {id: "BN", name: "🇧🇳 Brunei Darussalam (BN)"},
    {id: "BG", name: "🇧🇬 Bulgaria (BG)"},
    {id: "BF", name: "🇧🇫 Burkina Faso (BF)"},
    {id: "BI", name: "🇧🇮 Burundi (BI)"},
    {id: "CV", name: "🇨🇻 Cabo Verde (CV)"},
    {id: "KH", name: "🇰🇭 Cambodia (KH)"},
    {id: "CM", name: "🇨🇲 Cameroon (CM)"},
    {id: "KY", name: "🇰🇾 Cayman Islands (KY)"},
    {id: "CF", name: "🇨🇫 Central African Republic (CF)"},
    {id: "TD", name: "🇹🇩 Chad (TD)"},
    {id: "CL", name: "🇨🇱 Chile (CL)"},
    {id: "CN", name: "🇨🇳 China (CN)"},
    {id: "CX", name: "🇨🇽 Christmas Island (CX)"},
    {id: "CC", name: "🇨🇨 Cocos (Keeling) Islands (CC)"},
    {id: "CO", name: "🇨🇴 Colombia (CO)"},
    {id: "KM", name: "🇰🇲 Comoros (KM)"},
    {id: "CK", name: "🇨🇰 Cook Islands (CK)"},
    {id: "CR", name: "🇨🇷 Costa Rica (CR)"},
    {id: "HR", name: "🇭🇷 Croatia (HR)"},
    {id: "CU", name: "🇨🇺 Cuba (CU)"},
    {id: "CW", name: "🇨🇼 Curacao (CW)"},
    {id: "CY", name: "🇨🇾 Cyprus (CY)"},
    {id: "CZ", name: "🇨🇿 Czech Republic (CZ)"},
    {id: "CI", name: "🇨🇮 Côte d'Ivoire (CI)"},
    {id: "CD", name: "🇨🇩 Democratic Republic Of Congo (CD)"},
    {id: "DJ", name: "🇩🇯 Djibouti (DJ)"},
    {id: "DM", name: "🇩🇲 Dominica (DM)"},
    {id: "DO", name: "🇩🇴 Dominican Republic (DO)"},
    {id: "EC", name: "🇪🇨 Ecuador (EC)"},
    {id: "EG", name: "🇪🇬 Egypt (EG)"},
    {id: "SV", name: "🇸🇻 El Salvador (SV)"},
    {id: "GQ", name: "🇬🇶 Equatorial Guinea (GQ)"},
    {id: "ER", name: "🇪🇷 Eritrea (ER)"},
    {id: "EE", name: "🇪🇪 Estonia (EE)"},
    {id: "ET", name: "🇪🇹 Ethiopia (ET)"},
    {id: "FK", name: "🇫🇰 Falkland Islands (FK)"},
    {id: "FO", name: "🇫🇴 Faroe Islands (FO)"},
    {id: "FJ", name: "🇫🇯 Fiji (FJ)"},
    {id: "GF", name: "🇬🇫 French Guiana (GF)"},
    {id: "PF", name: "🇵🇫 French Polynesia (PF)"},
    {id: "TF", name: "🇹🇫 French Southern Territories (TF)"},
    {id: "GA", name: "🇬🇦 Gabon (GA)"},
    {id: "GM", name: "🇬🇲 Gambia (GM)"},
    {id: "GE", name: "🇬🇪 Georgia (GE)"},
    {id: "GH", name: "🇬🇭 Ghana (GH)"},
    {id: "GI", name: "🇬🇮 Gibraltar (GI)"},
    {id: "GR", name: "🇬🇷 Greece (GR)"},
    {id: "GL", name: "🇬🇱 Greenland (GL)"},
    {id: "GD", name: "🇬🇩 Grenada (GD)"},
    {id: "GP", name: "🇬🇵 Guadeloupe (GP)"},
    {id: "GU", name: "🇬🇺 Guam (GU)"},
    {id: "GT", name: "🇬🇹 Guatemala (GT)"},
    {id: "GG", name: "🇬🇬 Guernsey (GG)"},
    {id: "GN", name: "🇬🇳 Guinea (GN)"},
    {id: "GW", name: "🇬🇼 Guinea-bissau (GW)"},
    {id: "GY", name: "🇬🇾 Guyana (GY)"},
    {id: "HT", name: "🇭🇹 Haiti (HT)"},
    {id: "HM", name: "🇭🇲 Heard Island And McDonald Islands (HM)"},
    {id: "HN", name: "🇭🇳 Honduras (HN)"},
    {id: "HK", name: "🇭🇰 Hong Kong (HK)"},
    {id: "HU", name: "🇭🇺 Hungary (HU)"},
    {id: "IS", name: "🇮🇸 Iceland (IS)"},
    {id: "IN", name: "🇮🇳 India (IN)"},
    {id: "ID", name: "🇮🇩 Indonesia (ID)"},
    {id: "IR", name: "🇮🇷 Iran, Islamic Republic Of (IR)"},
    {id: "IQ", name: "🇮🇶 Iraq (IQ)"},
    {id: "IE", name: "🇮🇪 Ireland (IE)"},
    {id: "IM", name: "🇮🇲 Isle Of Man (IM)"},
    {id: "IL", name: "🇮🇱 Israel (IL)"},
    {id: "JM", name: "🇯🇲 Jamaica (JM)"},
    {id: "JP", name: "🇯🇵 Japan (JP)"},
    {id: "JE", name: "🇯🇪 Jersey (JE)"},
    {id: "JO", name: "🇯🇴 Jordan (JO)"},
    {id: "KZ", name: "🇰🇿 Kazakhstan (KZ)"},
    {id: "KE", name: "🇰🇪 Kenya (KE)"},
    {id: "KI", name: "🇰🇮 Kiribati (KI)"},
    {id: "KP", name: "🇰🇵 Korea, Democratic People's Republic Of (KP)"},
    {id: "KR", name: "🇰🇷 Korea, Republic Of (KR)"},
    {id: "KW", name: "🇰🇼 Kuwait (KW)"},
    {id: "KG", name: "🇰🇬 Kyrgyzstan (KG)"},
    {id: "LA", name: "🇱🇦 Lao People's Democratic Republic (LA)"},
    {id: "LV", name: "🇱🇻 Latvia (LV)"},
    {id: "LB", name: "🇱🇧 Lebanon (LB)"},
    {id: "LS", name: "🇱🇸 Lesotho (LS)"},
    {id: "LR", name: "🇱🇷 Liberia (LR)"},
    {id: "LY", name: "🇱🇾 Libya (LY)"},
    {id: "LI", name: "🇱🇮 Liechtenstein (LI)"},
    {id: "LT", name: "🇱🇹 Lithuania (LT)"},
    {id: "LU", name: "🇱🇺 Luxembourg (LU)"},
    {id: "MO", name: "🇲🇴 Macao (MO)"},
    {id: "MK", name: "🇲🇰 Macedonia, The Former Yugoslav Republic Of (MK)"},
    {id: "MG", name: "🇲🇬 Madagascar (MG)"},
    {id: "MW", name: "🇲🇼 Malawi (MW)"},
    {id: "MY", name: "🇲🇾 Malaysia (MY)"},
    {id: "MV", name: "🇲🇻 Maldives (MV)"},
    {id: "ML", name: "🇲🇱 Mali (ML)"},
    {id: "MT", name: "🇲🇹 Malta (MT)"},
    {id: "MH", name: "🇲🇭 Marshall Islands (MH)"},
    {id: "MQ", name: "🇲🇶 Martinique (MQ)"},
    {id: "MR", name: "🇲🇷 Mauritania (MR)"},
    {id: "MU", name: "🇲🇺 Mauritius (MU)"},
    {id: "YT", name: "🇾🇹 Mayotte (YT)"},
    {id: "FM", name: "🇫🇲 Micronesia, Federated States Of (FM)"},
    {id: "MD", name: "🇲🇩 Moldova (MD)"},
    {id: "MC", name: "🇲🇨 Monaco (MC)"},
    {id: "MN", name: "🇲🇳 Mongolia (MN)"},
    {id: "ME", name: "🇲🇪 Montenegro (ME)"},
    {id: "MS", name: "🇲🇸 Montserrat (MS)"},
    {id: "MA", name: "🇲🇦 Morocco (MA)"},
    {id: "MZ", name: "🇲🇿 Mozambique (MZ)"},
    {id: "MM", name: "🇲🇲 Myanmar (MM)"},
    {id: "NA", name: "🇳🇦 Namibia (NA)"},
    {id: "NR", name: "🇳🇷 Nauru (NR)"},
    {id: "NP", name: "🇳🇵 Nepal (NP)"},
    {id: "NC", name: "🇳🇨 New Caledonia (NC)"},
    {id: "NZ", name: "🇳🇿 New Zealand (NZ)"},
    {id: "NI", name: "🇳🇮 Nicaragua (NI)"},
    {id: "NE", name: "🇳🇪 Niger (NE)"},
    {id: "NG", name: "🇳🇬 Nigeria (NG)"},
    {id: "NU", name: "🇳🇺 Niue (NU)"},
    {id: "NF", name: "🇳🇫 Norfolk Island (NF)"},
    {id: "MP", name: "🇲🇵 Northern Mariana Islands (MP)"},
    {id: "OM", name: "🇴🇲 Oman (OM)"},
    {id: "PK", name: "🇵🇰 Pakistan (PK)"},
    {id: "PW", name: "🇵🇼 Palau (PW)"},
    {id: "PS", name: "🇵🇸 Palestinian Territory, Occupied (PS)"},
    {id: "PA", name: "🇵🇦 Panama (PA)"},
    {id: "PG", name: "🇵🇬 Papua New Guinea (PG)"},
    {id: "PY", name: "🇵🇾 Paraguay (PY)"},
    {id: "PE", name: "🇵🇪 Peru (PE)"},
    {id: "PH", name: "🇵🇭 Philippines (PH)"},
    {id: "PN", name: "🇵🇳 Pitcairn (PN)"},
    {id: "PL", name: "🇵🇱 Poland (PL)"},
    {id: "PT", name: "🇵🇹 Portugal (PT)"},
    {id: "QA", name: "🇶🇦 Qatar (QA)"},
    {id: "CG", name: "🇨🇬 Republic Of Congo (CG)"},
    {id: "RE", name: "🇷🇪 Reunion (RE)"},
    {id: "RO", name: "🇷🇴 Romania (RO)"},
    {id: "RU", name: "🇷🇺 Russian Federation (RU)"},
    {id: "RW", name: "🇷🇼 Rwanda (RW)"},
    {id: "BL", name: "🇧🇱 Saint Barthélemy (BL)"},
    {id: "SH", name: "🇸🇭 Saint Helena, Ascension And Tristan Da Cunha (SH)"},
    {id: "KN", name: "🇰🇳 Saint Kitts And Nevis (KN)"},
    {id: "LC", name: "🇱🇨 Saint Lucia (LC)"},
    {id: "MF", name: "🇲🇫 Saint Martin (MF)"},
    {id: "PM", name: "🇵🇲 Saint Pierre And Miquelon (PM)"},
    {id: "VC", name: "🇻🇨 Saint Vincent And The Grenadines (VC)"},
    {id: "WS", name: "🇼🇸 Samoa (WS)"},
    {id: "SM", name: "🇸🇲 San Marino (SM)"},
    {id: "ST", name: "🇸🇹 Sao Tome and Principe (ST)"},
    {id: "SA", name: "🇸🇦 Saudi Arabia (SA)"},
    {id: "SN", name: "🇸🇳 Senegal (SN)"},
    {id: "RS", name: "🇷🇸 Serbia (RS)"},
    {id: "SC", name: "🇸🇨 Seychelles (SC)"},
    {id: "SL", name: "🇸🇱 Sierra Leone (SL)"},
    {id: "SG", name: "🇸🇬 Singapore (SG)"},
    {id: "SX", name: "🇸🇽 Sint Maarten (SX)"},
    {id: "SK", name: "🇸🇰 Slovakia (SK)"},
    {id: "SI", name: "🇸🇮 Slovenia (SI)"},
    {id: "SB", name: "🇸🇧 Solomon Islands (SB)"},
    {id: "SO", name: "🇸🇴 Somalia (SO)"},
    {id: "ZA", name: "🇿🇦 South Africa (ZA)"},
    {id: "GS", name: "🇬🇸 South Georgia And The South Sandwich Islands (GS)"},
    {id: "SS", name: "🇸🇸 South Sudan (SS)"},
    {id: "LK", name: "🇱🇰 Sri Lanka (LK)"},
    {id: "SD", name: "🇸🇩 Sudan (SD)"},
    {id: "SR", name: "🇸🇷 Suriname (SR)"},
    {id: "SJ", name: "🇸🇯 Svalbard And Jan Mayen (SJ)"},
    {id: "SZ", name: "🇸🇿 Swaziland (SZ)"},
    {id: "SE", name: "🇸🇪 Sweden (SE)"},
    {id: "CH", name: "🇨🇭 Switzerland (CH)"},
    {id: "SY", name: "🇸🇾 Syrian Arab Republic (SY)"},
    {id: "TW", name: "🇹🇼 Taiwan (TW)"},
    {id: "TJ", name: "🇹🇯 Tajikistan (TJ)"},
    {id: "TZ", name: "🇹🇿 Tanzania, United Republic Of (TZ)"},
    {id: "TH", name: "🇹🇭 Thailand (TH)"},
    {id: "TL", name: "🇹🇱 Timor-Leste, Democratic Republic of (TL)"},
    {id: "TG", name: "🇹🇬 Togo (TG)"},
    {id: "TK", name: "🇹🇰 Tokelau (TK)"},
    {id: "TO", name: "🇹🇴 Tonga (TO)"},
    {id: "TT", name: "🇹🇹 Trinidad And Tobago (TT)"},
    {id: "TN", name: "🇹🇳 Tunisia (TN)"},
    {id: "TR", name: "🇹🇷 Turkey (TR)"},
    {id: "TM", name: "🇹🇲 Turkmenistan (TM)"},
    {id: "TC", name: "🇹🇨 Turks And Caicos Islands (TC)"},
    {id: "TV", name: "🇹🇻 Tuvalu (TV)"},
    {id: "UG", name: "🇺🇬 Uganda (UG)"},
    {id: "UA", name: "🇺🇦 Ukraine (UA)"},
    {id: "AE", name: "🇦🇪 United Arab Emirates (AE)"},
    {id: "UM", name: "🇺🇲 United States Minor Outlying Islands (UM)"},
    {id: "UY", name: "🇺🇾 Uruguay (UY)"},
    {id: "UZ", name: "🇺🇿 Uzbekistan (UZ)"},
    {id: "VU", name: "🇻🇺 Vanuatu (VU)"},
    {id: "VA", name: "🇻🇦 Vatican City State (VA)"},
    {id: "VE", name: "🇻🇪 Venezuela, Bolivarian Republic Of (VE)"},
    {id: "VN", name: "🇻🇳 Viet Nam (VN)"},
    {id: "VG", name: "🇻🇬 Virgin Islands (British) (VG)"},
    {id: "VI", name: "🇻🇮 Virgin Islands (US) (VI)"},
    {id: "WF", name: "🇼🇫 Wallis And Futuna (WF)"},
    {id: "EH", name: "🇪🇭 Western Sahara (EH)"},
    {id: "YE", name: "🇾🇪 Yemen (YE)"},
    {id: "ZM", name: "🇿🇲 Zambia (ZM)"},
    {id: "ZW", name: "🇿🇼 Zimbabwe (ZW)"},
];

export default COUNTRIES;
